// TopBarContext.tsx
import React from 'react';

export type MobileNavButtonDescriptor = {
  type: 'close' | 'custom';
  icon?: string;
  onClick: () => void;
};

export const TopBarContext = React.createContext({
  setTopBarContent: (content: React.ReactNode | null) => {},
  setNavButton: (button: React.ReactNode | MobileNavButtonDescriptor | null) => {},
  openCopilot: undefined as (() => void) | undefined,
  topBarContent: null as React.ReactNode | null,
  navButton: null as React.ReactNode | MobileNavButtonDescriptor | null,
});
